import { render, staticRenderFns } from "./AccountDeleted.vue?vue&type=template&id=a61c96ba&scoped=true"
import script from "./AccountDeleted.vue?vue&type=script&lang=ts"
export * from "./AccountDeleted.vue?vue&type=script&lang=ts"
import style0 from "./AccountDeleted.vue?vue&type=style&index=0&id=a61c96ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61c96ba",
  null
  
)

export default component.exports